/*
 * @Author: Teemo Ding
 * @Date: 2022-02-10 17:34:46
 * @LastEditTime: 2022-06-06 16:52:11
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationDetail/index.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getCommunicationDetail } from 'src/request/auditTrail/communication';
import CommunicationDetails from './CommunicationDetails';
import { breadcrumbData } from './tool';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = () => {
  const view_communication_audit_trail_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Communication,
        subCategory: EnumSubCategory.CommunicationAuditTrail,
        operation: EnumOperation.view_communication_audit_trail_details_page,
      }),
    ],
  });

  return {
    view_communication_audit_trail_details_page,
  };
};
const CommunicationDetail = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_communication_audit_trail_details_page } = permissions();
  const history = useHistory();

  const { logUuid } = useParams() as any;
  const beforeGoBack = () => {
    history.push('/communicationList');
  };

  const { data = {} } = useRequest(() => getCommunicationDetail(logUuid), {
    ready: !!view_communication_audit_trail_details_page,
  });
  return (
    <Fragment>
      <CommonHeader
        breadcrumbData={breadcrumbData(data.uuid, { getI18n })}
        onGoBackClick={beforeGoBack}
      />
      <CommunicationDetails data={data} />
    </Fragment>
  );
};

export default CommunicationDetail;
